import React, { Fragment, useEffect, useState } from "react";
import { Stack, InputBase, Toolbar, Box, Typography } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import ImageAssets from "../../../assets";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from "../Layout.module.css";
import { webHeaderMenu } from "../../../core/json/HeaderMenuJson";
import { useDispatch, useSelector } from "react-redux";
import routesNames from "../../../routes/RouteNames";
import NotificationTooltip from "../../../pages/notifications/notification-tooltip/NotificationTooltip";
import NotificationContent from "../../../pages/notifications/notification-tooltip/NotificationContent";
import UploadTooltip from "../../../pages/upload/upload-tooltip/UploadTooltip";
import { exploreRedux } from "../../../redux/explore-redux/ExploreRedux";
import LinearProgress from "@mui/material/LinearProgress";
import strings from "../../../strings/Strings";
import MuiConfirmationDailog from "../../common/dailog/confirmation-dailog/MuiConfirmationDailog";

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundColor: alpha(theme.palette.primary.dark, 1),
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.dark, 0.8),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "26px",
  borderRadius: "15px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  // width: "20px",
  paddingLeft: "2rem",
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  img: {
    width: "1.7rem",
  },
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    height: "3rem",
    fontSize: "1.4rem",
    fontWeight: 300,
    fontFamily: "Comfortaa-Light",
    color: "var(--nonary-grey-color)",
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `4.6rem`,
    // border: "none",
    width: "100%",
    borderRadius: "12px",
    border: "solid 0.5px #a8aebc",
  },
}));

const Header = () => {
  const location: any = useLocation();
  const navigate = useNavigate();
  const exploreState = useSelector((state: any) => state.ExploreRedux);
  const createPostState = useSelector((state: any) => state.createPostRedux);
  const chatState = useSelector((state: any) => state.chatRedux);

  const [selectedPath, setSelectedPath] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [selectedNavMenu, setSelectedNavMenu] = useState("");
  const [openNotifications, setOpenNotifications] = useState(false);

  const createProjectState = useSelector((state: any) => state.CreateProjectRedux);

  console.log(openNotifications, "openNotifications")
  useEffect(() => {
    if (location.pathname === "/upload") {
      setSelectedPath("Upload");
    }
    if (location.pathname === "/notifications") {
      setSelectedPath("Notifications");
    }
    if (location.pathname.includes("/profile/others-profile")) {
      setSelectedPath("Others");
    }
  }, [location.pathname]);

  const handleNavigate = (e, path) => {
    if (path === "/notifications") {

    }
    else {
      setOpenNotifications(false)
      if (location.pathname === "/upload/create-project") {
        if (createProjectState.projectDetails.basicProjectInfo.name) {
          e.preventDefault();
          setShowConfirmationPopup(true);
          setSelectedNavMenu(path);
        }
        else {
          navigate(path);
        }
      }
      else if (location.pathname === "/upload/create-post") {
        if (createPostState?.postDetails?.mediaContent?.length > 0) {
          e.preventDefault();
          setShowConfirmationPopup(true);
          setSelectedNavMenu(path);
        } else {
          navigate(path);
        }
      }
      else {
        navigate(path);
      }
    }
  }

  const handleConfirmClick = () => {
    navigate(selectedNavMenu);
    setShowConfirmationPopup(false);
  }

  const actionDispatch = (dispatch: any) => ({
    setExploreState: (data: any) =>
      dispatch(exploreRedux.actions.setExploreState(data)),
  });

  const { setExploreState } = actionDispatch(useDispatch());

  const handleMenuPath = (event: any, label: string) => {
    console.log("label", "kjkdjkdj")
    if (label === "Upload" || label === "Notifications") {
      setSelectedPath(label);
    } else {
      setSelectedPath("");
    }
    setExploreState({
      key: "searchKey",
      value: "",
    });
  };

  useEffect(() => {
    if (location?.pathname === "/notifications") {
      setOpenNotifications(true);
    }
  }, [location])

  return (
    <>
      {showConfirmationPopup ? (
        <MuiConfirmationDailog
          fisrtButtonLabel={strings.no}
          secondButtonLabel={strings.yes}
          isOpen={showConfirmationPopup}
          handleCancel={() => setShowConfirmationPopup(false)}
          handleSave={handleConfirmClick}
        >
          <Typography className={styles["confirmation-description"]}>
            Are you sure you want to discard the changes?
          </Typography>
        </MuiConfirmationDailog>
      ) : null}
      <AppBar sx={{ display: "flex" }} className={styles["appbar"]}>
        <Toolbar
          component="nav"
          sx={{
            justifyContent: "space-between",
            pr: { md: 4 },
            height: "100%",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              mr: { sm: 0, md: 0, lg: 0, xl: 2 },
            }}
          >
            <img
              src={ImageAssets.ic_sekeron_logo}
              style={{ width: "155px", cursor: "pointer" }}
              alt="search"
              onClick={() => navigate(routesNames.home)}
            />
          </Box>
          <Box
            sx={{
              flexGrow: { md: 1, lg: 1 },
            }}
          />
          <Box
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
              width: { md: "48%", lg: "45%", xl: "40%" },
              mr: { sm: "1rem" },
            }}
          >
            <Stack
              rowGap={5}
              sx={{
                justifyContent: { xs: "space-between" },
                alignItems: { xs: "center" },
                width: { md: "100%", lg: "90%", xl: "90%" },
              }}
            >
              {webHeaderMenu.map((item: any, index: number) => {
                return (
                  <NavLink
                    key={index}
                    to={item?.path}
                    className={({ isActive }) =>
                      (isActive || location?.pathname === item.path) &&
                        selectedPath !== "Others"
                        ? styles["menu-item-active"]
                        : styles["menu-item"]
                    }
                    onClick={(event) => handleNavigate(event, item?.path)}
                    children={({ isActive }) => (
                      <Fragment>
                        {item.label === "Notifications" ? (
                          <>
                            <img
                              className={styles["nav-menu-icons"]}
                              src={
                                openNotifications
                                  ? item.activeIcon
                                  : item.icon
                              }
                              style={{ position: 'relative' }}
                              alt={item.label}
                              onClick={() => setOpenNotifications(!openNotifications)}
                            />
                          </>
                        ) :
                          item?.label === "Chat" && chatState?.unreadMessages === true ?
                            <>
                              <div style={{ position: "relative" }}>
                                <span
                                  onClick={(event: any) =>
                                    handleMenuPath(event, item.label)
                                  }
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    className={styles["nav-menu-icons"]}
                                    src={
                                      (isActive || location?.pathname === item.path)
                                        ? item.activeIcon
                                        : item.icon
                                    }
                                    alt="nav-menu-icons"
                                  />
                                </span>
                                <div style={{
                                  position: "absolute", top: 0, right: 0,
                                  height: "0.8rem", width: '0.8rem', backgroundColor: '#ea4566', borderRadius: '100%'
                                }}></div>
                              </div>
                            </>
                            :
                            (
                              <>
                                <span
                                  onClick={(event: any) =>
                                    handleMenuPath(event, item.label)
                                  }
                                >
                                  <img
                                    className={styles["nav-menu-icons"]}
                                    src={
                                      (isActive || location?.pathname === item.path) &&
                                        selectedPath !== "Others"
                                        ? item.activeIcon
                                        : item.icon
                                    }
                                    alt="nav-menu-icons"
                                  />
                                  {/* {isActive ? <Typography className={styles["list-item-text"]}>{item.label}</Typography> : null} */}
                                </span>
                              </>
                            )}
                      </Fragment>
                    )}

                  />
                );
              })}
            </Stack>
            {selectedPath === "Upload" && (
              <Stack
                sx={{
                  position: "absolute",
                  right: { md: "10%", lg: "16%", xl: "21.5%" },
                }}
              >
                <UploadTooltip
                  setSelectedPath={setSelectedPath}
                  isMobile={false}
                />
              </Stack>
            )}
          </Box>
        </Toolbar>
        {createPostState?.isPostCreating && (
          <Box sx={{ width: "100%" }}>
            <LinearProgress />
          </Box>
        )}
      </AppBar>
      {openNotifications ?
        <NotificationTooltip
          openNotification={openNotifications}
          onCloseNotification={setOpenNotifications}
          label={"Notifications"}
          title={<NotificationContent onCloseNotification={setOpenNotifications} />}
        >
          {" "}
        </NotificationTooltip>
        : null
      }
    </>
  );
};

export default Header;
